export const socketConstants = {
  SOCKETINFOS_SUCCESS: 'SOCKETINFOS_SUCCESS',
};
export const socketConstantsTime = {
  SOCKETINFOS_SUCCESS_TIME: 'SOCKETINFOS_SUCCESS_TIME',
};
